// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e5b2dfb0","453":"ce4227e7","732":"bea39322"}[chunkId] + ".chunk.js";
};